module.exports = __webpack_public_path__ + "img/logo-ISO9001_bw.c18fcb2e.png";